import { useEffect, useState } from "react"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"
import { Calendar, ChevronRight, CheckCircle } from "lucide-react"

export default function Diagnosticswidget() {

  const [data, setData] = useState(null)

  useEffect(() => {
    fetch("/wp-json/custom/v1/diagnostics")
      .then(res => res.json())
      .then(res => setData(res))
  }, [])

  if (!data) return null

  return (
    <section className="py-12 bg-gray-100">
      <div className="container px-4 mx-auto">

        <div className="grid items-center grid-cols-1 gap-8 md:grid-cols-2">

          <div>
            <Badge className="mb-2">Diagnostics</Badge>

            <h2 className="mb-4 text-3xl font-bold md:text-4xl">
              {data.title}
            </h2>

            <p className="mb-6 text-[#485260]">
              {data.description}
            </p>

            <ul className="space-y-3 mb-6">
              {data.features?.map((item, index) => (
                <li key={index} className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-primary" />
                  <span>{item.text}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-wrap gap-4">

              <Button className="gap-2" asChild>
                <a href={data.btn1_link}>
                  {data.btn1_text || "Book a Test"}
                  <Calendar className="w-4 h-4" />
                </a>
              </Button>

              <Button
                variant="outline"
                className="gap-2 border-primary text-primary hover:bg-primary hover:text-white"
                asChild
              >
                <a href={data.btn2_link}>
                  {data.btn2_text || "View All Tests"}
                  <ChevronRight className="w-4 h-4" />
                </a>
              </Button>

            </div>
          </div>

          <div className="relative h-64 overflow-hidden rounded-lg md:h-80 lg:h-[500px]">
            <img
              src={data.image?.url || data.image}
              alt="Diagnostics"
              className="object-contain rounded-lg w-full h-full"
            />
          </div>

        </div>

      </div>
    </section>
  )
}